import React from 'react';
import ReactDOM from 'react-dom/client';
// #332: translations and the Accept-Language interceptor, before anything renders or calls the API.
import './i18n';
// #672: query parameters fully percent-encoded + network failures in the UI language.
import './axiosSetup';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";

const store = configureStore({ reducer: rootReducer, devTools: true });

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

// No service worker any more (it kept serving old builds after a deploy). Browsers that still run the old
// one are cured by public/service-worker.js (self-removing); this drops any registration left over.
// (WAS: registered /service-worker.js and alerted "A new version is available".)
if ("serviceWorker" in navigator) {
    navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => registrations.forEach((registration) => registration.unregister()))
        .catch(() => {});
}
